import "bootstrap/js/dist/modal";

RegisterController.$inject = ["Authentication.RegisterServices", "$state", "$rootScope"];

function RegisterController(RegisterServices, state, rootScope) {

    var self = this;
    // ثبت نام کاربر حقوقی (شرکت)

    self.register = async function (company, form) {
        if (form.$valid) {

            let parameter = {
                type: "LegalPersons"
            };

            await RegisterServices.create(parameter, company).$promise.then(response => {
                company = {};
                form.$setUntouched();
                form.$setPristine();
                iziToast.show({
                    message: response.message,
                    theme: 'light',
                    color: 'green',
                });

                state.go("Authentication.Verification", {
                    "id": response.content
                });


            }, errResponse => {
                iziToast.show({
                    message: errResponse.data.message,
                    theme: 'light',
                    color: 'red',
                });
            });

        }
        // else {
        //     iziToast.show({
        //         message: 'فرم را تکمیل کنید.',
        //         theme: 'light',
        //         color: 'red',
        //     });
        // }
    };

    // ثبت نام کاربر حقیقی (شخص)

    self.registerIndi = async function (company, form) {
        if (form.$valid) {

            let parameter = {
                type: "IndividualPersons",
                type2: "register"
            };

            await RegisterServices.createIndi(parameter, company).$promise.then(response => {
                company = {};
                form.$setUntouched();
                form.$setPristine();
                iziToast.show({
                    message: response.message,
                    theme: 'light',
                    color: 'green',
                });

                state.go("Authentication.Verification", {
                    "id": response.content
                });


            }, errResponse => {
                iziToast.show({
                    message: errResponse.data.message,
                    theme: 'light',
                    color: 'red',
                });
            });

        }
        // else {
        //     iziToast.show({
        //         message: 'فرم را تکمیل کنید.',
        //         theme: 'light',
        //         color: 'red',
        //     });
        // }
    };

    $('#descriptionModal').modal('show')

}

module.exports = ngModule => {

    ngModule.controller('Authentication.RegisterController', RegisterController);

};